import React from 'react';
import { Routes, Route } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';
import Layout from './components/common/Layout';
import HomePage from './pages/Home/Home';
import ShopPage from './pages/Shop/Shop';
import ProductDetailPage from './pages/ProductDetail/ProductDetail';
import CartPage from './pages/Cart/Cart';
import './App.css';

function App() {
  return (
    <>
      <Helmet>
        <title>श्रीPATI · Luxury, Without the occasion. Crafted to Shine Everyday</title>
        <meta name="description" content="Premium gold and silver imitation jewellery - श्रीPATI" />
        <link rel="preconnect" href="https://fonts.googleapis.com" />
        <link rel="preconnect" href="https://fonts.gstatic.com" crossOrigin="true" />
        <link href="https://fonts.googleapis.com/css2?family=Playfair+Display:ital,wght@0,400;0,600;0,700;1,400&family=Inter:wght@300;400;500;600;700&display=swap" rel="stylesheet" />
      </Helmet>
      <Routes>
        <Route path="/" element={<Layout />}>
          <Route index element={<HomePage />} />
          <Route path="shop" element={<ShopPage />} />
          <Route path="product/:id" element={<ProductDetailPage />} />
          <Route path="cart" element={<CartPage />} />
        </Route>
      </Routes>
    </>
  );
}

export default App;